import React from "react";
import SearchableList from "@components_common/components/utils/SearchableList";

const BucketAggregationContainerElement = ({ valuesCmp }) => {
  return <SearchableList items={valuesCmp} />;
};

export default BucketAggregationContainerElement;
